import { OrganizationCategory } from "../../../services/organizations/types";

export const getOrganizationCategories = (): OrganizationCategory[] => {
	return [
		OrganizationCategory.CLUB,
		OrganizationCategory.RESTAURANT,
		OrganizationCategory.CAFE,
		OrganizationCategory.FOODTRUCK,
		OrganizationCategory.PUB_BAR,
		OrganizationCategory.SUSHI,
		OrganizationCategory.SHOP,
		OrganizationCategory.OTHERS,
	];
};
